import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    minHeight: "100vh",
    alignItems: "center",
    backgroundColor: "#EDF2F7",
    padding: theme.spacing(2),
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    width: "100%",
    maxWidth: "500px",
    padding: theme.spacing(4),
    gap: "8px",
    margin: "auto",
    boxShadow:
      "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
    borderRadius: theme.spacing(1),
    backgroundColor: "#FFF",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(4),
  },
  backIcon: {
    width: 32,
    height: 32,
    cursor: "pointer",
  },
  logo: {
    width: 48,
    height: 48,
  },
  titleCon: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  titleHeading: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    display: "flex",
    alignItems: "left",
  },
  onboardingTitle: {
    color: "#2158D0",
    fontSize: "20px",
    textAlign: "center",
    fontWeight: 700,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  onboardingHeading: {
    color: "#000000",
    fontSize: "20px",
    textAlign: "center",
    fontWeight: 700,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  submitBtn: {
    background: "#5C91FF",
    color: "#FFFFFF",
    marginTop: "20px",
    textTransform: "capitalize",
    borderRadius: 6,
    padding: "11px 11px",
    marginBottom: theme.spacing(2),
    "&:hover": {
      background: "#5C91FF",
    },
    fontWeight: 700,
    fontSize: "20px",
  },
  searchInput: {
    backgroundColor: "#F3F7FF",
    borderRadius: 8,
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  checkBoxIcon: {
    border: "1.5px solid gray",
    width: 18,
    height: 18,
    display: "inline-block",
    borderRadius: 4,
    backgroundColor: "white",
  },
  checkedIcon: {
    border: "1.5px solid #2158D0",
    width: 18,
    height: 18,
    display: "inline-block",
    borderRadius: 4,
    backgroundColor: "white",
    position: "relative",
  },
  alertIconWrapper:{
    display:'flex',
    gap:'10px'
  },
  popover: {
    "& .MuiPopover-paper": {
      maxWidth: "400px",
      padding: "20px",
    },
  },
  alertHeadingwrapper:{
    display:'flex', 
    alignItems:'justify',
    flexDirection:'column', 
    justifyContent:'left',  
    textAlign:'justify'
  },
  logoWrapper:{
    "& img":{
      width:'180px',
      [theme.breakpoints.down("md")]: {
        width: "180px", 
      },
  
      [theme.breakpoints.down("sm")]: {
        width: "120px", 
      },
  
      [theme.breakpoints.down("xs")]: {
        width: "100px", 
      },

    }
  },
communityListWrapper:{
 backgroundColor: "#F3F7FF",
  maxHeight:'275px',
  overflowY:'scroll',
  scrollbarWidth: 'thin'
}
  
}));

export default useStyles;
